import { render, staticRenderFns } from "./RealIntentionForm.vue?vue&type=template&id=531efdd2"
import script from "./RealIntentionForm.vue?vue&type=script&lang=js"
export * from "./RealIntentionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports